import * as accountApi from '../../openapi-client/gen/api/account-rest-controller/account-rest-controller'
import * as accountApiWithoutChecks from '../../openapi-client/gen/api/withoutChecks/account-rest-controller/account-rest-controller'
import * as associationMembershipApi
	from '../../openapi-client/gen/api/association-membership-rest-controller/association-membership-rest-controller'
import * as associationMembershipApiWithoutChecks
	from '../../openapi-client/gen/api/withoutChecks/association-membership-rest-controller/association-membership-rest-controller'
import * as associationApi from '../../openapi-client/gen/api/association-rest-controller/association-rest-controller'
import * as associationApiWithoutChecks from '../../openapi-client/gen/api/withoutChecks/association-rest-controller/association-rest-controller'
import * as devApi from '../../openapi-client/gen/api/dev-rest-controller/dev-rest-controller'
import * as devApiWithoutChecks from '../../openapi-client/gen/api/withoutChecks/dev-rest-controller/dev-rest-controller'
import * as faqApi from '../../openapi-client/gen/api/faq-rest-controller/faq-rest-controller'
import * as faqApiWithoutChecks from '../../openapi-client/gen/api/withoutChecks/faq-rest-controller/faq-rest-controller'
import * as identityVerificationApi from '../../openapi-client/gen/api/identity-verification-rest-controller/identity-verification-rest-controller'
import * as identityVerificationApiWithoutChecks
	from '../../openapi-client/gen/api/withoutChecks/identity-verification-rest-controller/identity-verification-rest-controller'
import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin(() => {
	return {
		provide: {
			api: {
				accountApi,
				associationMembershipApi,
				associationApi,
				devApi,
				faqApi,
				identityVerificationApi,
			},
			apiWithoutChecks: {
				accountApi: accountApiWithoutChecks,
				associationMembershipApi: associationMembershipApiWithoutChecks,
				associationApi: associationApiWithoutChecks,
				devApi: devApiWithoutChecks,
				faqApi: faqApiWithoutChecks,
				identityVerificationApi: identityVerificationApiWithoutChecks,
			},
		},
	}
})
